import React, { useEffect, useRef, useState } from "react";
import { Alert, Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, MenuItem, Stack, TextField } from '@mui/material'

// import { JsonToTable } from "react-json-to-table";
import './table.css'
import { LoadingButton, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Api } from "../../../components/api";
import DriverTreeViewTable from "./DriverTreeViewTable";
import DriverJsonToCsvExport from "./DriverJsonToCsvExport";
import { Form, FormikProvider, useFormik } from "formik";
import { fDateTo } from "../../../utils/formatTime";
import * as Yup from 'yup';
import axios from "axios";
import { format } from "date-fns";
import _ from "lodash";
import { useSnackbar } from "notistack";
import DriverJsonToTable from "./DriverJsonToTable";
import CryptoJS from 'crypto-js';
import { CircleNotifications, Close, CloudDownload } from "@mui/icons-material";
import LoadingDriverPopover from "./LoadingDriverPopover";

const aesEncryptECBHex = (plaintext) => {
    const password = "vIOm4x1FCctkwx0K"
    const key = CryptoJS.enc.Utf8.parse(password.padEnd(16, ' '));
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
};



export default function DriverLogToTable({ userId, account }) {
    const { enqueueSnackbar } = useSnackbar();
    const handleSnackbar = ({ variant, message }) => {
        enqueueSnackbar(message, { variant, autoHideDuration: 2000, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } });
    };

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [maxPage, setMaxPage] = useState(null);
    const [loading, setLoading] = useState(false);


    const [drivers, setDrivers] = useState([])
    const [masterReport, setMasterReport] = useState([])
    const [checked, setChecked] = useState([])
    const [checkedData, setCheckedData] = useState([]);

    const [type, setType] = useState({})
    const [originalData, setOriginalData] = useState([])


    const [rangStart, setRangStart] = useState(null);
    const [rangEnd, setRangEnd] = useState(null);
    const [rangMax, setRangMax] = useState(null);


    const [openAlert, setOpenAlert] = useState(false);



    useEffect(() => {
        Api.get(`https://api.sitgps.com/Tracking/v3/gps_report?type=002`)
            .then((res) => {
                setMasterReport(res.data)
            })
            .catch(err => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
            })
    }, [])

    useEffect(() => {
        Api.get(`https://api.sitgps.com/Tracking/get_driver?cname=${account.contype === "00" ? `${aesEncryptECBHex("*")}` : `${aesEncryptECBHex(account.c_coname)}`}`).then((res) => {
            var list = res.data.map(d => {
                return {
                    value: d.driver_id,
                    label: d.name,
                    value_og: d
                }
            });
            setDrivers(list)
        }
        ).catch(err => {
            const Message = err?.response?.data?.msg || "Unknown error";
            if (Message) {
                handleSnackbar({ variant: "error", message: `${Message}` })
            }
        })
    }, [userId])





    const initialTime = new Date();
    const schema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues: {
            date_s: fDateTo(initialTime.setHours(0, 0, 0), 'yyyy-MM-dd HH:mm'),
            date_e: fDateTo(initialTime.setHours(23, 59, 59), 'yyyy-MM-dd HH:mm'),
        },
        validationSchema: schema,
        onSubmit: (values, { setSubmitting }) => {
            onSubmitGetData({ setSubmitting: setSubmitting, page: 1 })
            onGetCount()
        }
    })

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;



    const onGetCount = () => {
        setMaxPage(null)
        setRangMax(null)
        const { date_s, date_e } = values
        const reqC = {
            dateStart: fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
            dateEnd: fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
            report: type?.id,
            list: checked
        }

        Api.post(`https://historyv2.sitgps.com/Tracking/report_driver_count`, reqC)
            .then((res) => {
                const { data } = res
                const totalPages = Math.ceil(data.msg / pageSize);
                setMaxPage(totalPages)
                setRangMax(data.msg === 0 ? null : data.msg)
            }).catch(err => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
                setMaxPage(null)
            })
    }


    const onSubmitGetData = ({ setSubmitting = () => { }, page = 1 }) => {

        if (checked.length <= 0) {
            handleSnackbar({ variant: "error", message: `กรุณาเลือกพนักงานขับรถที่ต้องการดู` })
            setSubmitting()
            return
        }
        setLoading(true)

        const { date_s, date_e } = values
        const req = {
            dateStart: fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
            dateEnd: fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
            page: page,
            page_size: pageSize,
            report: type?.id,
            list: checked
        }
        Api.post(`${type?.value?.api?.url}`, req)
            .then((res) => {
                const { data } = res
                setRangStart(data?.msg?.rang_start)
                setRangEnd(data?.msg?.rang_end)
                setOriginalData(data?.msg?.data)
                setSubmitting()
                setLoading(false)
                setPage(page)
            })
            .catch((err) => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
                onClear()
                setSubmitting()
            })
    }



    const [openPopover, setOpenPopover] = useState(false);

    const handleOpen = () => {
        setOpenPopover(true)
    };

    const handleClose = () => {
        setOpenPopover(false)
    };


    const handleExport = () => {
        setLoading(true)
        const { date_s, date_e } = values
        const req = {
            "username": userId,
            report: type?.id,
            "dateStart": fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
            "dateEnd": fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
            "list": checked
        }

        Api.post(`https://historyv2.sitgps.com/Tracking/report_by_page_export`, req)
            .then((res) => {
                handleSnackbar({ variant: "success", message: `กำลังสร้างไฟล์ กรุณากด ปุ่มดาวน์โหลด เมื่อสร้างสำเร็จ` })
                setLoading(false)
                handleOpen()
            }).catch(err => {
                setLoading(false)
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                    console.log('err', err?.response?.data?.msg)

                }

                // setLoading(false)
                // setPage(1)
                // setMaxPage(1)
            })
    }


    const handleExportAlert = () => {
        handleCloseAlert()
        handleExport()
    }
    const handleOpenAlert = () => {
        setOpenAlert(true)
    };
    const handleCloseAlert = () => {
        setOpenAlert(false)
    };


    const onChangeChecked = (data) => {
        setChecked(data)
        onClear()
    }
    const onChangeCheckedData = (data) => {
        setCheckedData(data)
        onClear()
    }




    const onClear = () => {
        // originalData([])
        setPage(1)
        setRangStart(null)
        setRangEnd(null)
        setMaxPage(null)
        setLoading(false)
        setOriginalData([])
    }
    return (
        <div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ minWidth: "20%", maxWidth: "20%", minHeight: "calc(100vh)", maxHeight: "calc(100vh)", overflow: "auto" }}>
                        <Box sx={{ padding: "10px" }}>
                            <DriverTreeViewTable
                                nodes={drivers}
                                checked={checked}
                                setChecked={onChangeChecked}
                                checkedData={checkedData}
                                setCheckedData={onChangeCheckedData}
                                maxHeight={"calc(100vh - 118px)"}
                                height={"calc(100vh - 118px)"}
                                multi={!type?.value?.device_only}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ minWidth: "calc(80% - 10px)", maxWidth: "calc(80% - 10px)", minHeight: "calc(100vh)", maxHeight: "calc(100vh)", overflow: "hidden" }}>
                        <Box sx={{ padding: "10px", maxWidth: "100%", overflow: "auto" }}>
                            <FormikProvider value={formik}>
                                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                    <Grid container spacing={1}>
                                        <Grid item md={3}>
                                            <TextField
                                                label="ประเภทรายงาน"
                                                fullWidth
                                                autoComplete="off"
                                                name="iframe"
                                                size="small"
                                                select
                                                value={type.id}
                                                onChange={(e) => {
                                                    const selected = masterReport.find((r) => r.id === e.target.value);
                                                    setType(selected);
                                                    onClear()
                                                    if (selected?.value?.device_only && checked.length > 1) {
                                                        setChecked([])
                                                    }
                                                }}
                                            >
                                                {masterReport.map((iframe) => (
                                                    <MenuItem key={iframe.id} value={iframe.id}>
                                                        {iframe.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_s}
                                                onChange={(val) => {
                                                    onClear()
                                                    const { value } = val.target
                                                    setFieldValue('date_s', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                    setFieldValue('date_e', `${fDateTo(new Date(value).setHours(23, 59, 59), "yyyy-MM-dd HH:mm")}`);

                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_s && errors.date_s)}
                                                helperText={touched.date_s && errors.date_s}
                                                label="วันเวลาเริ่ม"
                                                inputProps={{
                                                    // readOnly: true,
                                                    ampm: false,
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_e}
                                                onChange={(val) => {
                                                    onClear()

                                                    const { value } = val.target
                                                    setFieldValue('date_e', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_e && errors.date_e)}
                                                helperText={touched.date_e && errors.date_e}
                                                label="ถึงวันเวลา"
                                                readOnly={true}
                                                inputProps={{
                                                    // readOnly: true,
                                                    ampm: false,
                                                    min: fDateTo(new Date(values.date_s), "yyyy-MM-dd HH:mm"),
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <Stack direction="row" spacing={1} justifyContent="space-around">
                                                <LoadingButton disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0} variant="contained" type="submit" loading={isSubmitting}>ค้นหา</LoadingButton>
                                                <IconButton onClick={handleOpenAlert}
                                                    disabled={originalData.length <= 0}
                                                    color="secondary" aria-label="CloudDownload">
                                                    <CloudDownload />
                                                </IconButton>
                                                <IconButton onClick={handleOpen} aria-label="CircleNotifications">
                                                    <CircleNotifications />
                                                </IconButton>

                                                <LoadingDriverPopover
                                                    open={openPopover}
                                                    onClose={handleClose}
                                                    userId={userId}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </FormikProvider>
                        </Box>
                        <Box sx={{ padding: "10px", maxWidth: "calc(100% - 10px)", minHeight: "calc(100vh - 110px)", maxHeight: "calc(100vh - 110px)", overflow: "auto" }}>
                            <DriverJsonToTable data={originalData} />
                        </Box>
                        <Box sx={{ padding: "10px" }}>
                            <Stack direction={1} justifyContent="space-between">
                                <Box>
                                    <Button
                                        variant="contained"
                                        disabled={page === 1}
                                        onClick={() => {
                                            onSubmitGetData({ page: page - 1 })
                                        }}
                                        size="small">
                                        Prev
                                    </Button>
                                    <span style={{ margin: "0 10px", userSelect: "none" }}>{rangStart === null ? `${`NA`}` : `${rangStart} - `} {rangEnd === null ? `${`NA`}` : `${rangEnd}`} {rangMax === null ? `${` / NA`}` : ` / ${rangMax.toLocaleString("en-US")}`}</span>
                                    <Button
                                        variant="contained"
                                        disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0 || page === maxPage || originalData.length === 0}
                                        onClick={() => {
                                            onSubmitGetData({ page: page + 1 })
                                        }}
                                        size="small"
                                    >
                                        Next
                                    </Button>
                                </Box>
                                <Box>
                                    <select
                                        size="small"
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                    >
                                        <option key={`setPageSize-1`} value={10}>
                                            {10}
                                        </option>
                                        <option key={`setPageSize-2`} value={20}>
                                            {20}
                                        </option>
                                        <option key={`setPageSize-3`} value={30}>
                                            {30}
                                        </option>
                                        <option key={`setPageSize-4`} value={40}>
                                            {40}
                                        </option>
                                        <option key={`setPageSize-5`} value={50}>
                                            {50}
                                        </option>
                                    </select>
                                </Box>
                            </Stack>
                        </Box>
                    </Box>
                </Stack>
            </LocalizationProvider>


            <Dialog onClose={handleCloseAlert} open={openAlert} fullWidth maxWidth="sm">
                <DialogTitle>
                    แจ้งเตือน
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseAlert}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Alert color="warning">
                        ต้องการเริ่มสร้างไฟล์ส่งออกหรือไม่?
                        <br />
                        การสร้างไฟล์อาจใช้เวลาสักครู่ กรุณากดเพียงครั้งเดียว
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" size="small" color="primary" onClick={handleExportAlert}>ยืนยัน</Button>
                    <Button variant="contained" size="small" color="secondary" onClick={handleCloseAlert}>ยกเลิก</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}